export const OFFER_FULFILLMENT_OPTIONS = [
  { value: 'RETAIL', label: 'Retail' },
  { value: 'SERVICE', label: 'Service' },
  { value: 'RETAIL_AND_SERVICE', label: 'Retail and service' },
]

export const OFFER_FULFILLMENT_VALUES = OFFER_FULFILLMENT_OPTIONS.map(
  ({ value }) => value
)

export const getOfferFulfillmentLabel = (value) =>
  OFFER_FULFILLMENT_OPTIONS.find(
    (option) => option.value === String(value || '').toUpperCase()
  )?.label || ''

export const isOfferFulfillmentType = (value) =>
  OFFER_FULFILLMENT_VALUES.includes(value)
